export const environment = {
  GRAPHQL_CLIENT_NAME: 'fluxcontrol:client:production',
  GRAPHQL_CLIENT_VERSION: '85d48-20260109',
  ENVIRONMENT: 'production',
  PRODUCTION: true,
  BASE_URL: 'https://app.fluxcontrol.com.br/#/',
  SENTRY_DNS: '',
  ISENGARD_URL: 'https://isengard.fluxcontrol.com.br/api/graphql',
  ISENGARD_REALTIME_URL: 'wss://socket.fluxcontrol.com.br/socket',
  API_BRADESCO_URL: 'https://bradesco.fluxcontrol.com.br/api/graphql',
  ORODRUIN3_URL: 'https://bradesco.fieldcontrol.com.br/patrimonio/#!/',
  AWS_S3_BUCKET_URL: 'https://s3.us-east-1.amazonaws.com/attachments.fluxcontrol.com.br',
  BUCKET_NAME: 'attachments.fluxcontrol.com.br',
  SENTRY_ENV: 'production',
  SENTRY_ENABLED: true,
  GLEAP_ENABLED: true,
  GLEAP_API_KEY: 'ycYqOYkQLwC0Fu4t1jRryb7aJd2m1lOo',
};
